import React from "react";
import { graphql } from "gatsby";
import { Testimonials } from "./Testimonials";
import {
  KontentComponentSettings,
  KontentComponentLayout,
  KontentLinkedImage,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatImages } from "../../../lib/images";

interface Props extends KontentComponentSettings, KontentComponentLayout {
  testimonials: {
    value: {
      id: string;
      elements: {
        headline: StringValue;
        subheadline: StringValue;
        text: StringValue;
        image: KontentLinkedImage;
      };
    }[];
  };
}

const TestimonialsContainer: React.FC<Props> = ({ testimonials, ...props }) => {
  const settings = getComponentSettings(props);
  const testimonialItems = testimonials?.value?.map((testimonial) => {
    const imageItem = testimonial.elements.image?.value[0]
      ? formatImages(testimonial.elements.image.value[0].elements)
      : undefined;

    return {
      id: testimonial.id,
      headline: testimonial.elements.headline?.value,
      subheadline: testimonial.elements.subheadline?.value,
      text: testimonial.elements.text?.value,
      image: imageItem?.largeImage,
    };
  });

  return <Testimonials testimonials={testimonialItems} {...settings} />;
};

export default TestimonialsContainer;

export const fragmentTestimonialsContainer = graphql`
  fragment Testimonials on kontent_item_testimonials {
    system {
      id
      codename
    }
    internal {
      type
      contentDigest
    }
    elements {
      testimonials {
        value {
          ... on kontent_item_testimonial_item {
            id
            elements {
              headline {
                value
              }
              subheadline {
                value
              }
              text {
                value
              }
              image {
                value {
                  ...kontentImage
                }
              }
            }
          }
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
